"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonTypesI18N = void 0;
exports.CommonTypesI18N = {
    constants: {
        highchartsArrow: "➤"
    },
    retentionType: {
        retentionTypeTypeToIntervalName: (retentionType) => {
            switch (retentionType) {
                case "nDay":
                    return "Day";
                case "nWeek":
                    return "Week";
                case "nMonth":
                    return "Month";
            }
        }
    }
};
